export const statusList = ["CART", "GENERATED", "PIX", "PROCESSED", "PENDING", "APPROVED", "CANCELED", "HOLD", "SENT", "QUEUE", "GRADING", "GRADED", "AWAITING", "RETURNED", "DELIVERED", "DONE", "ANALYZING"];

export const statusObject = {
    "CART": "CARRINHO",
    "GENERATED": "CRIADO PELO ADMIN",
    "PIX": "PIX GERADO",
    "PROCESSED": "PAGAMENTO PROCESSADO",
    "PENDING": "PAGAMENTO PENDENTE",
    "APPROVED": "PAGAMENTO AUTORIZADO",
    "CANCELED": "PAGAMENTO CANCELADO",
    "HOLD": "AGUARDANDO MANAFIX",
    "SENT": "ENVIADO PARA MANAFIX",
    "QUEUE": "RECEBIDO",
    "GRADING": "AVALIANDO",
    "GRADED": "EM PROCESSO DE LACRE",
    "AWAITING": "AGUARDANDO RETIRADA",
    "RETURNED": "ENVIADO PARA CLIENTE",
    "DELIVERED": "ENTREGUE (LEGADO)",
    "DONE": "FINALIZADO",
    "ANALYZING": "EM ANALISE"
}

export const statusFlow = {
    correios: {
        "CART": "CARRINHO",
        "PROCESSED": "PAGAMENTO PROCESSADO",
        "APPROVED": "PAGAMENTO AUTORIZADO",
        "SENT": "ENVIADO PARA MANAFIX",
        "QUEUE": "RECEBIDO",
        "GRADING": "AVALIANDO",
        "GRADED": "EM PROCESSO DE LACRE",
        "RETURNED": "ENVIADO PARA CLIENTE",
        "DONE": "FINALIZADO"
    },
    presencial: {
        "CART": "CARRINHO",
        "PROCESSED": "PAGAMENTO PROCESSADO",
        "APPROVED": "PAGAMENTO AUTORIZADO",
        "QUEUE": "RECEBIDO",
        "GRADING": "AVALIANDO",
        "GRADED": "EM PROCESSO DE LACRE",
        "AWAITING": "AGUARDANDO RETIRADA",
        "DONE": "FINALIZADO"
    },
    hub: {
        "CART": "CARRINHO",
        "PROCESSED": "PAGAMENTO PROCESSADO",
        "APPROVED": "PAGAMENTO AUTORIZADO",
        "HOLD": "AGUARDANDO MANAFIX",
        "QUEUE": "RECEBIDO",
        "GRADING": "AVALIANDO",
        "GRADED": "EM PROCESSO DE LACRE",
        "AWAITING": "AGUARDANDO RETIRADA",
        "DONE": "FINALIZADO"
    }
}

export const getNextStatus = (delivery, status, isHQ) => {
    try {
        if (!delivery || !status) {
            return null;
        }
        if (!["correios", "presencial"].includes(delivery)) {
            return null;
        }
        let statusList = statusFlow[delivery];
        if (isHQ === false) {
            statusList = statusFlow["hub"];
        }
        const keys = Object.keys(statusList);
        const key = keys.indexOf(status);
        if (key + 1 >= keys.length) {
            return null;
        }
        return keys[key + 1];
    } catch (e) {
        console.log("erro");
    }
}

export const partnerStatusList = ["GENERATED", "APPROVED", "HOLD", "QUEUE", "AWAITING", "DONE", "ANALYZING"];

export const partnerStatusObject = {
    "GENERATED": "CRIADO PELO ADMIN",
    "APPROVED": "PAGAMENTO AUTORIZADO",
    "HOLD": "AGUARDANDO MANAFIX",
    "QUEUE": "RECEBIDO PELA MANAFIX",
    "AWAITING": "AGUARDANDO RETIRADA",
    "DONE": "FINALIZADO",
    "ANALYZING": "EM ANALISE"
}

export const disablePartnerStatusList = ["GRADING", "GRADED"];

export const getNextPartnerStatus = (status) => {
    try {
        if (!status) {
            return null;
        }
        const keys = Object.keys(partnerStatusObject);
        const key = keys.indexOf(status);
        if (key + 1 >= keys.length) {
            return null;
        }
        return keys[key + 1];
    } catch (e) {
        console.log("erro");
    }
}
